import React from 'react';
import {Outlet} from "react-router-dom";
import {Grid} from "@mui/material";
import Header from "../components/login/Header";

const LoginLayout = () => {
    const bgColor = '#e5e5e5';

    return (
        <Grid container >
            <Grid sx={{position: {xs: 'sticky', lg: 'static'}, top: 0, zIndex: 1299,}} item xs={12} md={12} lg={12}>
                <Header/>
            </Grid>
            <Grid style={{width: "100%", backgroundColor: bgColor}} justifyContent={"center"} display={"flex"}>
                <Grid sx={{flexGrow: 1, width: '100%',marginX:'30px',marginY:'20px'}}>
                    <Outlet/>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LoginLayout;